import { BasePortfolio } from '@ddt-web/domain';
import { PortfolioIdUtil } from '@ddt-web/portfolio-data';
import * as get from 'lodash/get';

import { BpasEngagement } from '../domain/bpas-engagement.model';
import { EngagementsFlags } from '../domain/engagements-flags.model';

export class EngagementsUtil {

	public static createNewEngagement(currency: string): BpasEngagement {
		return new BpasEngagement([], '', { isActive: true } as EngagementsFlags, currency);
	}

	public static getBenchmarkNameFromEngagement(engagement: BpasEngagement): string {
		const portfolioId = engagement.benchmarkDetails.benchmarkId;
		if (PortfolioIdUtil.isUserPortfolio(portfolioId)) {
			const benchmarkPortfolio = get(engagement, 'children', []).find((child: BasePortfolio) => child.uniqueId === portfolioId);
			return benchmarkPortfolio.description;
		} else {
			return portfolioId;
		}
	}
}
